import { SxProps } from '@mui/material';
import { useTranslation } from 'react-i18next';
import PlaceholderImg from '../../../../../assets/hex_placeholder.svg';
import Badge, {
  defaultExerciseBadge,
} from '../../../../components/badge/badge';
import { GalleryCard } from '../../../../components/gallery/LibraryGalleryCard';
import { GalleryViewMode } from '../../../../components/gallery/types';
import { ExerciseTagChips } from '../../../block/slots/ExerciseTagChips';
import { LibraryExercise } from '../types';

export const ExerciseCard = ({
  item,
  viewMode,
  sx,
  onClick,
  showTags = false,
}: {
  item: LibraryExercise;
  viewMode: GalleryViewMode;
  sx?: SxProps;
  onClick: (item: LibraryExercise) => void;
  /**
   * Opt-in movement-tag chip row (alternate-exercise picker only). Off for every
   * other usage so existing cards render exactly as before.
   */
  showTags?: boolean;
}) => {
  const { t } = useTranslation();
  const { name, imageUrl } = item;
  return (
    <GalleryCard
      sx={sx}
      title={
        <div className="flex items-center justify-between flex-wrap">
          {name}
          {item.isDefault && <Badge {...defaultExerciseBadge(t)} />}
        </div>
      }
      imgUrl={imageUrl ?? PlaceholderImg}
      imgAlt={name}
      viewMode={viewMode}
      onClick={() => onClick(item)}
    >
      {showTags && <ExerciseTagChips tags={item.tags} />}
    </GalleryCard>
  );
};
